import { createContext } from "react";

import { DlpContext } from "../providers/dlpFlow/DlpFlow.interfaces";

export const DlpFlowContext = createContext<DlpContext | undefined>(undefined);
